/*
Notes:用户操作ajax Api
Date:2018/8/30 by Hgwn
*/

import ajax from './ajax'
export default {

    //下面Api是跟用户注册、登录、找回密码相关接口 hgwn 3/9
    //注---参考标准版 信贷产品接口。
    login:function(params){ // 标准版信贷 是用get ，建议接口统一，采用resetFull风格
        // Request URL: http://localhost:8121/api/crmform/customer/crmCustomer/login.ht?loginName=13427557711&password=G8eISokmMnHkIALIr%2BFLEnAjpTozYcha6c8bi9UItyUexAL1e77L9acGmTSDDuz87B26eDjeZqHMIhEZii%2FXHBaZbKJVzvhcD%2FPgL1pIhXLAJ9lHVO4TIoOWSjR8EZMCvm%2FtEb3tAnAJ6iY76YCyZOvKGPMB5bi1ctEEllSY4uw%3D
        return ajax.get(`/crmform/customer/crmCustomer/login.ht`,params);
    },
    exit:function(params){ //退出接口 ok
        return ajax.get(`/crmform/customer/crmCustomer/exit.ht`,params)
    },
    generateRSAPublicKey:function(params){ // 获取 generateRSAPublicKey 3/9 不需传参
        return ajax.get(`/agent/generateRSAPublicKey.ht`,params);
    },
    getUserMenuList:function(id){
        return ajax.get(`/dlsys/portal/console/access/operator/tree/`+id);
    },
    modifyPwd:function(params){ //修改密码
        return ajax.postForm(`/dlsys/portal/console/operator/updpwd/`,params)
    },
    getRegisterContract:function(params){ //获取注册协议 3/9 不需传参
        return ajax.get(`/cmsform/site/cmssitemenucontent/getRegisterContract.ht`,params)
    }
};



// WEBPACK FOOTER //
// ./src/api/user.js